export default __webpack_public_path__ + "static/media/gif4.37783bcc.gif";